import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const RedirectToBrowseEC = () => {
  const [searchParams, _setSearchParams] = useSearchParams();
  return <Navigate to={{ pathname: 'ec', search: `?${searchParams.toString()}` }} replace />;
};

export default RedirectToBrowseEC;
